export const aboutData = {
    title: "Who I am",
    description1: "My name is Elsa Heitz. I am currently finishing my master of Robotics with a minor in data sciences at EPFL and will be graduating on October 2026.",
    description2: "My academic journey has allowed me to develop strong technical and problem-solving skills, which I am eager to further enhance. I wish to apply my skills to meaningful projects that align with my values, particularly in fields like energy, sustainability, transport and medicine, where engineering can contribute to great positive change. To that end, I am actively seeking either permanent positions or fixed-term contracts starting from October 2026.",
    image: 2
}

